<div id="main_loader" *ngIf="loader">
  <div class="loader-wrapper">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>

<div class="popup-overlay" *ngIf="emailinvalid">
  <div class="popup-content">
    <h2>Invalid Email</h2>
    <p>
      Please use your Bajaj Capital email address. To try again,
      <a class="clickable-link" style="color: #007bff; cursor: pointer; text-decoration: underline" onmouseover="this.style.color='#0056b3'" onmouseout="this.style.color='#007bff'" (click)="handleInvalidEmail()">click here</a>.
    </p>
  </div>
</div>


<div id="userInactiveModal" class="popup-overlay" *ngIf="isUserInactive">
  <div class="popup-content">
    <div class="popup-icon error-icon"></div>
    <h2>Account Inactive</h2>
    <p>
      Your account is currently inactive. Please contact support or try again later.
    </p>
    <button class="popup-btn" (click)="handleInactiveUser()">OK</button>
  </div>
</div>


<div class="popup-overlay" *ngIf="userNotFound">
  <div class="popup-content">
    <h2>Invalid User</h2>
    <p>
       Please use a valid user account.To try again,
      <a class="clickable-link" style="color: #007bff; cursor: pointer; text-decoration: underline" onmouseover="this.style.color='#0056b3'" onmouseout="this.style.color='#007bff'" (click)="handleInvalidEmail()">click here</a>.
    </p>
  </div>
</div>
